import React, { ChangeEvent, useState } from 'react'
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CFormInput,
  CRow,
  CSpinner,
  CTabContent,
} from '@coreui/react-pro'
import { useEditBudgetItem } from './hooks'
import { setSection, submitEditSection } from './model'

export const EditSection = () => {
  const [validated, setValidated] = useState(false)

  const { section, loading } = useEditBudgetItem()

  const handleChange = (
    event: ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    let value = event.currentTarget.value

    setSection({
      ...section,
      [event.currentTarget.name]: value,
    })
  }

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const form = event.currentTarget

    if (!form.checkValidity()) {
      event.preventDefault()
      event.stopPropagation()
    } else {
      submitEditSection(section)
      event.preventDefault()
      event.stopPropagation()
    }
    setValidated(true)
  }

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center">
        <CSpinner />
      </div>
    )
  }

  return (
    <CCard className="mb-4">
      <CCardHeader className="d-sm-flex justify-content-between align-items-center">
        <strong>Edit section</strong>
      </CCardHeader>
      <CCardBody>
        <CTabContent className="pt-3">
          <CForm noValidate validated={validated} onSubmit={handleSubmit}>
            <CRow className="mb-3">
              <CCol sm={4}>
                <CFormInput
                  type="text"
                  id="name"
                  name="name"
                  value={section.name}
                  onChange={handleChange}
                  label="Name"
                  required
                />
              </CCol>
            </CRow>
            <CButton className="mb-3" type="submit">
              Edit
            </CButton>
          </CForm>
        </CTabContent>
      </CCardBody>
    </CCard>
  )
}
